import { combineReducers } from 'redux';
import {
    STUDIO_O_AUTH_DIALOG_SHOW,
    STUDIO_O_AUTH_DIALOG_HIDE,
    STUDIO_O_AUTH_SUCCESS_DIALOG_SHOW,
    STUDIO_O_AUTH_SUCCESS_DIALOG_HIDE,
    STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR,
    STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS,
    STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    STUDIO_YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS,
    STUDIO_YOUTUBE_O_AUTH_URL_FETCH_ERROR,
    STUDIO_YOUTUBE_O_AUTH_URL_FETCH_SUCCESS,
    STUDIO_TWITCH_O_AUTH_URL_FETCH_SUCCESS,
    STUDIO_TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS,
    STUDIO_TWITCH_O_AUTH_URL_FETCH_ERROR,
    STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS,
    STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_ERROR,
    STUDIO_FACEBOOK_O_AUTH_URL_FETCH_SUCCESS,
    STUDIO_FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS,
    STUDIO_FACEBOOK_O_AUTH_URL_FETCH_ERROR,
    STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS,
    STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR,
    ADD_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS,
    ADD_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    ADD_STUDIO_LIVE_STREAM_DESTINATION_ERROR,
    ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW,
    ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE,
    ADD_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET,
    DELETE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS,
    DELETE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    DELETE_STUDIO_LIVE_STREAM_DESTINATION_ERROR,
    DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW,
    DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE,
    UPDATE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS,
    UPDATE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    UPDATE_STUDIO_LIVE_STREAM_DESTINATION_ERROR,
    UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW,
    UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE,
    UPDATE_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET,
    FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_SUCCESS,
    FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_IN_PROGRESS,
    FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_ERROR,
    UPDATE_DESTINATIONS_TO_LIVE_STREAM_ERROR,
    UPDATE_DESTINATIONS_TO_LIVE_STREAM_IN_PROGRESS,
    UPDATE_DESTINATIONS_TO_LIVE_STREAM_SUCCESS,
} from '../../constants/mediaNodes/studio';

const oAuthDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case STUDIO_O_AUTH_DIALOG_SHOW:
        return {
            ...state,
            open: true,
        };
    case STUDIO_O_AUTH_DIALOG_HIDE:
        return {
            ...state,
            open: false,
        };
    default:
        return state;
    }
};

const oAuthSuccessDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case STUDIO_O_AUTH_SUCCESS_DIALOG_SHOW:
        return {
            ...state,
            open: true,
        };
    case STUDIO_O_AUTH_SUCCESS_DIALOG_HIDE:
        return {
            ...state,
            open: false,
        };
    default:
        return state;
    }
};

const studioYoutubeOAuth = (state = {
    url: '',
    urlInProgress: false,
    callback: '',
    callbackInProgress: false,
}, action) => {
    switch (action.type) {
    case STUDIO_YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            urlInProgress: true,
        };
    case STUDIO_YOUTUBE_O_AUTH_URL_FETCH_SUCCESS:
        return {
            ...state,
            url: action.value,
            urlInProgress: false,
        };
    case STUDIO_YOUTUBE_O_AUTH_URL_FETCH_ERROR:
        return {
            ...state,
            urlInProgress: false,
        };
    case STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS:
        return {
            ...state,
            callbackInProgress: true,
        };
    case STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS:
        return {
            ...state,
            callback: action.value,
            callbackInProgress: false,
        };
    case STUDIO_YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR:
        return {
            ...state,
            callbackInProgress: false,
        };
    default:
        return state;
    }
};

const studioTwitchOAuth = (state = {
    url: '',
    urlInProgress: false,
    callback: '',
    callbackInProgress: false,
}, action) => {
    switch (action.type) {
    case STUDIO_TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            urlInProgress: true,
        };
    case STUDIO_TWITCH_O_AUTH_URL_FETCH_SUCCESS:
        return {
            ...state,
            url: action.value,
            urlInProgress: false,
        };
    case STUDIO_TWITCH_O_AUTH_URL_FETCH_ERROR:
        return {
            ...state,
            urlInProgress: false,
        };
    case STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS:
        return {
            ...state,
            callbackInProgress: true,
        };
    case STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS:
        return {
            ...state,
            callback: action.value,
            callbackInProgress: false,
        };
    case STUDIO_TWITCH_O_AUTH_CALLBACK_FETCH_ERROR:
        return {
            ...state,
            callbackInProgress: false,
        };
    default:
        return state;
    }
};

const studioFacebookOAuth = (state = {
    url: '',
    urlInProgress: false,
    callback: '',
    callbackInProgress: false,
}, action) => {
    switch (action.type) {
    case STUDIO_FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS:
        return {
            ...state,
            urlInProgress: true,
        };
    case STUDIO_FACEBOOK_O_AUTH_URL_FETCH_SUCCESS:
        return {
            ...state,
            url: action.value,
            urlInProgress: false,
        };
    case STUDIO_FACEBOOK_O_AUTH_URL_FETCH_ERROR:
        return {
            ...state,
            urlInProgress: false,
        };
    case STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS:
        return {
            ...state,
            callbackInProgress: true,
        };
    case STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS:
        return {
            ...state,
            callback: action.value,
            callbackInProgress: false,
        };
    case STUDIO_FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR:
        return {
            ...state,
            callbackInProgress: false,
        };
    default:
        return state;
    }
};

const studioLiveStreamDestinations = (state = {
    inProgress: false,
    result: {},
}, action) => {
    switch (action.type) {
    case FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_SUCCESS:
        return {
            ...state,
            inProgress: false,
            result: action.value,
        };
    case FETCH_STUDIO_LIVE_STREAM_DESTINATIONS_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const addDestinationDialog = (state = {
    open: false,
    inProgress: false,
    result: {},
    value: {
        destination: {
            name: 'YouTube',
            value: 'youtube',
        },
        url: '',
        key: '',
        enabled: true,
        username: '',
    },
}, action) => {
    switch (action.type) {
    case ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW:
        return {
            ...state,
            open: true,
        };
    case ADD_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE:
        return {
            ...state,
            open: false,
            value: {
                destination: {
                    name: 'YouTube',
                    value: 'youtube',
                },
                url: '',
                key: '',
                enabled: true,
                username: '',
            },
        };
    case ADD_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET:
        return {
            ...state,
            value: action.value,
        };
    case ADD_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case ADD_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS:
        return {
            ...state,
            inProgress: false,
            result: action.value,
        };
    case ADD_STUDIO_LIVE_STREAM_DESTINATION_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const updateDestinationDialog = (state = {
    value: {},
    open: false,
    inProgress: false,
    result: {},
}, action) => {
    switch (action.type) {
    case UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW:
        return {
            ...state,
            open: true,
            value: action.value,
        };
    case UPDATE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE:
        return {
            ...state,
            open: false,
            value: {},
        };
    case UPDATE_STUDIO_LIVE_STREAM_DESTINATION_VALUE_SET:
        return {
            ...state,
            value: action.value,
        };
    case UPDATE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case UPDATE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS:
        return {
            ...state,
            inProgress: false,
            result: action.value,
        };
    case UPDATE_STUDIO_LIVE_STREAM_DESTINATION_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const deleteDestinationDialog = (state = {
    value: {},
    open: false,
    inProgress: false,
    result: {},
}, action) => {
    switch (action.type) {
    case DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_SHOW:
        return {
            ...state,
            open: true,
            value: action.value,
        };
    case DELETE_STUDIO_LIVE_STREAM_DESTINATION_DIALOG_HIDE:
        return {
            ...state,
            open: false,
            value: {},
        };
    case DELETE_STUDIO_LIVE_STREAM_DESTINATION_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case DELETE_STUDIO_LIVE_STREAM_DESTINATION_SUCCESS:
        return {
            ...state,
            inProgress: false,
            result: action.value,
        };
    case DELETE_STUDIO_LIVE_STREAM_DESTINATION_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const destinationsToLiveStream = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case UPDATE_DESTINATIONS_TO_LIVE_STREAM_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case UPDATE_DESTINATIONS_TO_LIVE_STREAM_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
        };
    case UPDATE_DESTINATIONS_TO_LIVE_STREAM_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

export default combineReducers({
    oAuthDialog,
    oAuthSuccessDialog,
    studioYoutubeOAuth,
    studioTwitchOAuth,
    studioFacebookOAuth,
    studioLiveStreamDestinations,
    addDestinationDialog,
    updateDestinationDialog,
    deleteDestinationDialog,
    destinationsToLiveStream,
});
